import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23cff37c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper forgetpwd" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cbim-logo-white" }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "main error-page"
}
const _hoisted_4 = { class: "error-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error-icon" }, "❌", -1))
const _hoisted_6 = { class: "error-title" }
const _hoisted_7 = { class: "error-actions" }
const _hoisted_8 = {
  key: 1,
  class: "main findpwd"
}
const _hoisted_9 = { class: "findpwd-title" }
const _hoisted_10 = { class: "findpwd-content" }
const _hoisted_11 = { class: "help" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "support@cbim.com", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_CbimSteps = _resolveComponent("CbimSteps")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.showErrorPage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.errorMessage), 1),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.goToHome
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('message.goToHome')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$t('message.wangjimima')), 1),
            _createVNode(_component_CbimSteps, {
              class: _normalizeClass(["cbim-steps", {'cbim-steps-en': _ctx.currentLanguage == 'en'}]),
              active: _ctx.currentStep,
              stepsTitle: _ctx.stepsTitle
            }, null, 8, ["class", "active", "stepsTitle"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(), _createBlock(_KeepAlive, null, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentComponent), {
                account: _ctx.account,
                verifyCode: _ctx.verifyCode,
                email: _ctx.email,
                countryCode: _ctx.countryCode,
                type: _ctx.type,
                usage: "findpwd",
                onGoNextProcess: _ctx.handleNextProcess
              }, null, 40, ["account", "verifyCode", "email", "countryCode", "type", "onGoNextProcess"]))
            ], 1024))
          ])
        ])),
    _createElementVNode("p", _hoisted_11, [
      _createTextVNode(_toDisplayString(_ctx.$t('message.zhaohuimimayudaokunnan')) + " ", 1),
      _hoisted_12,
      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.sendEmail')) + " ", 1),
      _hoisted_13,
      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.forHelp')), 1)
    ])
  ]))
}